import { simulatorText as simulatorGlobalText } from 'presentation/constant/globals'

export const simulatorText = simulatorGlobalText
export const fundAndSavingsInformationText = 'Información del fondo y ahorro'
export const travelVoteText = 'Votación viaje'
